module.exports = __webpack_public_path__ + "media/images/mobile_filters-68001654.png";